import React, { useEffect } from 'react';
import Topbar from '../components/Header/Topbar';
import Navbar from '../components/Header/Navbar';
import Spinner from '../components/Spinner/Spinner';
import Footer from '../components/Footer/Footer';
import BackToTop from '../components/BackToTop/BackToTop';
import SEO from '../components/SEO/SEO';
import $ from 'jquery';

const About = () => {
  useEffect(() => {
    // Initialize WOW.js
    if (window.WOW) {
      new window.WOW().init();
    }

    // Hide spinner
    setTimeout(() => {
      const spinner = document.getElementById('spinner');
      if (spinner) {
        spinner.classList.remove('show');
      }
    }, 500);

    // Back to top functionality
    $(window).scroll(function () {
      if ($(this).scrollTop() > 300) {
        $('.back-to-top').fadeIn('slow');
      } else {
        $('.back-to-top').fadeOut('slow');
      }
    });

    $('.back-to-top').click(function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 1500, 'easeInOutExpo');
      return false;
    });

    return () => {
      $(window).off('scroll');
      $('.back-to-top').off('click');
    };
  }, []);

  const pageHeaderStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/assets/solar-banaer.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    minHeight: '400px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <>
      <SEO 
        title="About Us"
        description="Learn more about Galaxy Power System, Chidambaram. We are trusted partners for power solutions, providing high-quality batteries and solar systems since years."
        keywords="about galaxy power system, battery dealer chidambaram history, power solutions experts"
        canonicalUrl="https://galaxypowersystems.com/about"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'About', url: '/about' }
        ]}
      />
      <Spinner />
      <Topbar />
      <Navbar />
      
      {/* Page Header */}
      <div className="container-fluid page-header py-5 mb-5" style={pageHeaderStyle}>
        <div className="container py-5">
          <h1 className="display-3 text-white mb-3 animated slideInDown">About Us</h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="/" className="text-white">Home</a></li>
              <li className="breadcrumb-item text-white active" aria-current="page">About</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* About Content */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <img src="/assets/galaxy-power-solution-chidambaram.jpg" className="img-fluid rounded" alt="About Galaxy Power" />

              {/* <video src="/assets/SOLAR-VIDEO.mp4" controls className="img-fluid rounded w-100" style={{height: '500px', objectFit: 'cover'}}></video> */}
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <h1 className="display-5 mb-4 fw-bold">About Galaxy Power System</h1>
              <p className="mb-4">
                Galaxy Power System is your trusted partner for all power solutions. We specialize in providing high-quality batteries, solar systems, and power backup solutions for residential, commercial, and industrial applications.
              </p>
              <p className="mb-4">
                With years of experience in the industry, we have established ourselves as a leading distributor of top brands like Exide, Luminous, Amaron, and more. Our commitment to quality and customer satisfaction sets us apart.
              </p>
              <div className="row g-4">
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <i className="fa fa-check  me-2" style={{color: '#DE400E'}}></i>
                    <span>Quality Products</span>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <i className="fa fa-check  me-2" style={{color: '#DE400E'}}></i>
                    <span>Expert Support</span>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <i className="fa fa-check  me-2" style={{color: '#DE400E'}}></i>
                    <span>Onsite Warranty</span>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <i className="fa fa-check  me-2" style={{color: '#DE400E'}}></i>
                    <span>Free Shipping</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      
      {/* Use the React BackToTop component */}
      <BackToTop />
    </>
  );
};

export default About;